import styled from 'styled-components';

export const CardContainer = styled.div<{ isDroppable: boolean }>`
    background: ${(props) => props.theme.palette.primaryA6};
    border: 2px dashed
        ${(props) => (props.isDroppable ? props.theme.palette.primaryA1 : 'transparent')};
    border-radius: 8px;
    padding: 20px;
    min-height: 344px;

    ${(props) => props.theme.breakpointTo.sm} {
        border: none;
        background-color: transparent;
        padding: 0;
    }

    &.white {
        background: ${(props) => props.theme.palette.primaryA7};
    }

    .camera-icon {
        width: 18.35px;
        height: 15px;
        transform: scale(1.4);
    }

    .badge {
        margin-left: auto;
        margin-right: auto;
        max-width: 100%;
    }

    .card {
        &-images-container {
            display: flex;
            gap: 12px;
            max-width: 100%;
            width: 100%;
            justify-content: center;
            align-items: center;
        }

        &-img {
            display: flex;
            flex: 1;
            max-width: 100%;

            ${(props) => props.theme.breakpointTo.sm} {
                width: auto;
                height: auto;
                max-width: 100%;
            }

            img {
                object-fit: contain;
                border-radius: 6px;
                max-width: 100%;

                ${(props) => props.theme.breakpointTo.sm} {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    margin: auto;
                }
            }
        }

        &-title {
            margin-bottom: 4px;
            text-align: center;

            ${(props) => props.theme.breakpointTo.sm} {
                display: none;
            }
        }

        &-row {
            display: flex;
            align-items: center;

            svg {
                margin-right: 8px;
            }
        }

        &-main {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 16px;

            ${(props) => props.theme.breakpointTo.sm} {
                gap: 16px;
            }

            .success-badge {
                ${(props) => props.theme.breakpointTo.sm} {
                    margin: auto;
                }
            }
        }

        &-wrapper {
            display: flex;
            justify-content: space-between;
            margin-top: 24px;

            ${(props) => props.theme.breakpointTo.sm} {
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 16px;
                margin-top: 0;
            }
        }

        &-icon-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 16px;
            font-size: 16px;
            line-height: 26px;

            .img {
                width: 50%;
                min-height: 121.5px;
                object-fit: contain;
            }
        }

        &-description {
            margin-top: 24px;
            max-width: 290px;
            text-align: center;

            ${(props) => props.theme.breakpointTo.sm} {
                display: none;
            }
        }

        &-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 48px;
        }

        &-drag-drop {
            position: relative;
        }
    }

    .requirements-button {
        margin-top: 24px;
    }

    .requirements-button-error {
        margin-top: 16px;
        margin-bottom: -8px;
    }
`;
